import AuthorizationMixin from './authorization-mixin';

export default {
  AuthorizationMixin,
};



// WEBPACK FOOTER //
// ./src/apps/auth/mixins/index.js